var React = require('react');

function RoundedSquareTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591zm-5.041-15c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z"}));
}

RoundedSquareTick.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RoundedSquareTick;

RoundedSquareTick.default = RoundedSquareTick;
